// Wave-J (loop-engineering nota-10) — CLASSIFY → AÇÃO: todo fim de run ruim é
// triado em needs_human | flaky | easy, cada classe com ação própria (o "loop
// action: escalated to you / retry / no action" da doutrina). Puro; o wrapper
// emite o evento e a camada de notificação age.

const NEEDS_HUMAN = new Set([
  'budget_exceeded', // hard-stop de dinheiro: decisão de gastar mais é SUA
  'content_filtered', // provider recusou: reformular é decisão editorial
  'context_overflow', // tarefa grande demais pro contexto: precisa re-escopo
  'tool_failure_spiral', // ambiente/repo quebrado além do env-repair
  'max_iterations', // não convergiu no teto: re-escopo ou dica humana
]);
const FLAKY = new Set([
  'model_error', // upstream caiu/timeout: retry costuma resolver
]);
const EASY = new Set([
  'stall_gave_up', 'identical_output_loop', 'tool_repeat_loop', // lição ExpeL já injetada; re-tentar é barato
]);

/**
 * @param {{ok?: boolean, stopReason?: string, error?: string, iterations?: number}} result
 * @returns {{klass: 'needs_human'|'flaky'|'easy', action: 'notify'|'retry_ok'|'lesson_only', stopReason: string, title: string, detail: string}|null}
 */
export function triageFailure(result) {
  const stop = String(result?.stopReason || '');
  if (!stop || result?.ok) return null; // done/conversational/plan = sem triagem
  if (stop === 'aborted') return null; // Stop do usuário não é falha
  if (NEEDS_HUMAN.has(stop)) {
    return {
      klass: 'needs_human', action: 'notify', stopReason: stop,
      title: `Apolo precisa de você (${stop})`,
      detail: String(result?.error || '').slice(0, 180) || `Run parou em ${stop} após ${result?.iterations ?? '?'} iterações — estado parcial no worktree/progress.`,
    };
  }
  if (FLAKY.has(stop)) {
    return { klass: 'flaky', action: 'retry_ok', stopReason: stop, title: `Falha transitória (${stop})`, detail: String(result?.error || '').slice(0, 180) };
  }
  if (EASY.has(stop)) {
    return { klass: 'easy', action: 'lesson_only', stopReason: stop, title: `Auto-corrigível (${stop})`, detail: 'Lição registrada; re-tentar é barato.' };
  }
  // stopReason desconhecido e ok:false — fail-safe: melhor pingar demais que sumir.
  return { klass: 'needs_human', action: 'notify', stopReason: stop, title: `Apolo parou (${stop})`, detail: String(result?.error || '').slice(0, 180) };
}
